// Where heavy work runs: in the browser or on the home server.

import { APP_MODE, caps } from '../config.svelte';

export type ComputeMode = 'client' | 'server' | 'auto';
const KEY = 'stereo.computeMode';

function load(): ComputeMode {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'client' || v === 'server' || v === 'auto') return v;
  } catch {
    /* ignore */
  }
  return 'auto';
}

export const computeMode = $state({ mode: load() });

export function setComputeMode(m: ComputeMode) {
  computeMode.mode = m;
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* ignore */
  }
}

/** True when the server-side choice is offered at all. */
export function serverAvailable(): boolean {
  return APP_MODE === 'full' && caps.compute;
}

/**
 * Resolves the target for a task. `auto` prefers the server for heavy work
 * (it has the GPU and the larger models) whenever it is reachable.
 */
export function computeTarget(): 'client' | 'server' {
  if (!serverAvailable()) return 'client';
  return computeMode.mode === 'client' ? 'client' : 'server';
}

/** Server-runnable depth models. */
export function serverModels() {
  return caps.models.filter((m) => m.where?.includes('server'));
}
